import { isBefore, subDays } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { queryKeys, queryValues } from '~/routes/query-params';
import { useMarketInsightsStore } from '~/views/dashboard/whats-new-widget/hooks/useMarketInsightsStore';
import { useWhatsNewSettings } from '~/views/dashboard/whats-new-widget/hooks/useWhatsNewSettings';
import { ReadMarketInsight } from '~/views/dashboard/whats-new-widget/utils';

import { useQueryParams } from '../use-query-params/useQueryParams';
import { READ_MARKET_INSIGHTS, useRemoteStorage } from '../use-remote-storage';

export const useMarketInsightsDrawer = () => {
  const { deleteQueryParam, setQueryParams } = useQueryParams();
  const { getActiveMarketInsightsGroup } = useMarketInsightsStore(state => ({
    getActiveMarketInsightsGroup: state.getActiveMarketInsightsGroup,
  }));
  const { storeItems } = useRemoteStorage();
  const { period } = useWhatsNewSettings();

  const openDrawer = (dateISO: string) => {
    const activeMarketInsightsGroup = getActiveMarketInsightsGroup(dateISO);

    if (activeMarketInsightsGroup) {
      const readItems: ReadMarketInsight =
        useRemoteStorage.getState().items?.[READ_MARKET_INSIGHTS] ?? {};

      const filteredReadItems = clearObsoleteReadKeys(readItems);

      const ids = activeMarketInsightsGroup.map(i => i.id);
      filteredReadItems[dateISO.split('T')[0]] = ids;

      storeItems({
        [READ_MARKET_INSIGHTS]: filteredReadItems,
      });
    }

    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.marketInsightDrawer,
      [queryKeys.activeDate]: dateISO,
    });
  };

  const clearObsoleteReadKeys = (readItems: ReadMarketInsight) => {
    const nDaysAgo = subDays(new Date(), period.duration + 1);
    const obsoleteKeys = Object.keys(readItems).filter(d =>
      isBefore(toZonedTime(d, 'UTC'), nDaysAgo)
    );

    const items = { ...readItems };

    for (const readKey of obsoleteKeys) {
      delete items[readKey];
    }

    return items;
  };

  const closeDrawer = () => {
    deleteQueryParam(
      [queryKeys.activeDrawer, queryKeys.activeDate, queryKeys.activeInsight],
      {
        replace: true,
      }
    );
  };

  return {
    openDrawer,
    closeDrawer,
  };
};
